import Immutable from "immutable";
import { floatToMoney } from "lib/money";

import * as studentLinked from "lib/appserver/entityHeaders/studentLinked";

const ClubHistoryItem = new Immutable.Record({
  description: undefined,
  startDate: undefined,
  endDate: undefined,
  booking: undefined,
  weeklyTotalAmount: undefined,
  paidAmount: undefined,
  dueAmount: undefined,
  ...studentLinked.defaultProperties
}, "Club History Item");

function buildClubHistoryItemFromAppserver(rawHistoryItem) {
  const rawClubHistoryItem = rawHistoryItem.payload;
  // TODO: fix this on the server end (hopefully?)
  rawHistoryItem.student_fk = rawClubHistoryItem.student_fk;
  return ClubHistoryItem({
    description: rawClubHistoryItem.payment_description,
    startDate: rawClubHistoryItem.club_start_date,
    endDate: rawClubHistoryItem.club_end_date,
    booking: buildBookingfromAppserver(rawClubHistoryItem),
    weeklyTotalAmount: floatToMoney(rawClubHistoryItem.weekly_total),
    paidAmount: floatToMoney(rawClubHistoryItem.amount_paid),
    dueAmount: floatToMoney(rawClubHistoryItem.amount_due),
    ...studentLinked.appserverAdapter(rawHistoryItem)
  })
}

function buildBookingfromAppserver(rawClubHistoryItem) {
  const bookings = new Immutable.List([
    rawClubHistoryItem.monday_booking,
    rawClubHistoryItem.tuesday_booking,
    rawClubHistoryItem.wednesday_booking,
    rawClubHistoryItem.thursday_booking,
    rawClubHistoryItem.friday_booking,
  ]);
  return bookings.map(booking => ({
    status: formatClubBookingStatus(booking.status),
    sessionNumber: booking.session_booked ? booking.booked_session_id : null
  }))
}

function formatClubBookingStatus(status) {
  switch (status) {
    case "Y":
      return "ATTENDED";
    case "N":
      return "NOT_ATTENDED";
    case "H":
      return "HOLIDAY";
    default:
      return "";
  }
}

ClubHistoryItem.fromAppserver = buildClubHistoryItemFromAppserver;
export default ClubHistoryItem;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/ClubHistoryItem.js